module.exports = __webpack_public_path__ + "static/media/Bluelab Sample Pot.adab8506.webp";